export default __webpack_public_path__ + "static/media/imagem_02.ad4b6046.jpg";